var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { TipoImovelEnum } from '../../../model/enums/TipoImovelEnum';
import { outrosOpt } from '../Cadastro/context/RequerimentoContext';
import dayjs from 'dayjs';
import { OrgaoResponsavelEnum } from '../../../model/enums/OrgaoResponsavelEnum';
import { DateUtils } from '../../../util/DateUtils';
import { prettyArea } from '../Cadastro/SegundaAba/DadosImovelUsucapiaoRural';
import { TipoAreaEnum } from '../../../model/enums/TipoAreaEnum';
import { TipoProprietarioEnum } from '../../../model/enums/TipoProprietarioEnum';
import { TipoDocDominioEnum } from '../../../model/enums/TipoDocDominioEnum';
import { PortariaRatificacaoUrbanaEnum } from '../../../model/enums/PortariaRatificacaoUrbanaEnum';
import { DocumentoAquisicaoEnum } from '../../../model/enums/DocumentoAquisicaoEnum';
import { TipoProcessoEnum } from '../../../model/enums/TipoProcessoEnum';
import { reverseDocumentoMap, reverseDocumentoMapPretty, } from '../Cadastro/SegundaAba/solicitarEstudoCadastral/SolicitarEstudoCadastral';
import { semMunicipioDeMt } from '../../../components/DadosParcelaMunicipio';
import { FinalidadeDeclaracaoEnum } from '../../../model/enums/FinalidadeDeclaracaoEnum';
import { emptyBlocks, resolveCondition, resolveExpress, resolveOptArrCondition, resolveOptCondition, } from './CommonView';
import { CommonUtils, NAO_SEI_INFO_MUNI_AT, NAO_SEI_INFO_MUNI_DESC, } from '../../../util/CommonUtils';
import { TipoParcelaEnum } from '../../../components/TipoParcelaEnum';
import 'dayjs/locale/pt-br';
export var projField = function (dados, projeto, other, loteamento, fullWidth, cohab) {
    var _a, _b, _c;
    if (projeto === void 0) { projeto = true; }
    if (other === void 0) { other = true; }
    if (loteamento === void 0) { loteamento = true; }
    if (fullWidth === void 0) { fullWidth = false; }
    if (cohab === void 0) { cohab = false; }
    var semProj = !((_a = dados === null || dados === void 0 ? void 0 : dados.projetoFundiario) === null || _a === void 0 ? void 0 : _a.id);
    var lbl = projeto ? 'Qual o Projeto?' : 'Qual o nome do Bairro?';
    var label = cohab ? 'Qual é o COHAB/Loteamento' : lbl;
    var value = (_b = (projeto ? dados === null || dados === void 0 ? void 0 : dados.outroProjeto : dados === null || dados === void 0 ? void 0 : dados.bairro)) !== null && _b !== void 0 ? _b : '';
    var lblProj = loteamento ? 'Loteamento' : 'Assentamento';
    var labelProj = cohab
        ? 'COHAB/Loteamento'
        : "Projeto de ".concat(lblProj);
    return [
        {
            label: labelProj,
            value: !semProj ? (_c = dados === null || dados === void 0 ? void 0 : dados.projetoFundiario) === null || _c === void 0 ? void 0 : _c.nome : outrosOpt === null || outrosOpt === void 0 ? void 0 : outrosOpt.denominacao,
            fullWidth: fullWidth && !semProj,
        },
        resolveOptCondition(other, resolveCondition(semProj, label, value)),
    ];
};
export var projQdrLotField = function (dados, projeto, projFullWidth, cohab) {
    var _a, _b, _c, _d;
    if (projeto === void 0) { projeto = true; }
    if (projFullWidth === void 0) { projFullWidth = false; }
    if (cohab === void 0) { cohab = false; }
    var semQdr = !((_a = dados === null || dados === void 0 ? void 0 : dados.quadra) === null || _a === void 0 ? void 0 : _a.id);
    var semLote = !((_b = dados === null || dados === void 0 ? void 0 : dados.lote) === null || _b === void 0 ? void 0 : _b.id);
    var qdrSize = !semQdr && (!semLote || projFullWidth) ? false : !semQdr;
    var loteSize = !semQdr && !semLote ? false : !semLote;
    var projSize = projFullWidth && (semQdr || (!semQdr && !semLote));
    return __spreadArray(__spreadArray([], projField(dados, projeto, true, true, projSize, cohab), true), [
        {
            value: !semQdr ? (_c = dados === null || dados === void 0 ? void 0 : dados.quadra) === null || _c === void 0 ? void 0 : _c.denominacao : outrosOpt === null || outrosOpt === void 0 ? void 0 : outrosOpt.denominacao,
            fullWidth: qdrSize,
            label: 'Quadra',
        },
        resolveCondition(semQdr, 'Qual a quadra?', dados === null || dados === void 0 ? void 0 : dados.outraQuadra),
        {
            value: !semLote ? (_d = dados === null || dados === void 0 ? void 0 : dados.lote) === null || _d === void 0 ? void 0 : _d.denominacao : outrosOpt === null || outrosOpt === void 0 ? void 0 : outrosOpt.denominacao,
            fullWidth: loteSize,
            label: 'Lote',
        },
        resolveCondition(semLote, 'Qual o lote?', dados === null || dados === void 0 ? void 0 : dados.outroLote),
    ], false);
};
export var dataOcpMMMMYYYY = function (dados, fullWidth) {
    if (fullWidth === void 0) { fullWidth = false; }
    return {
        label: 'Data de ocupação',
        value: (dados === null || dados === void 0 ? void 0 : dados.dataOcupacao)
            ? dayjs(new Date("".concat(dados === null || dados === void 0 ? void 0 : dados.dataOcupacao, " 23:00")))
                .locale('pt-br')
                .format('MMMM/YYYY')
            : '',
        fullWidth: fullWidth,
    };
};
export var primeiroOcpField = function (dados, fullWhenAlone) {
    if (fullWhenAlone === void 0) { fullWhenAlone = true; }
    var primeiro = (dados === null || dados === void 0 ? void 0 : dados.primeiroProprietario) === true;
    return [
        {
            label: 'É o primeiro proprietário do Imóvel?',
            value: primeiro ? 'Sim' : 'Não',
            fullWidth: fullWhenAlone,
        },
        resolveCondition(!primeiro, 'Nome Proprietário Anterior', dados === null || dados === void 0 ? void 0 : dados.nomeProprietarioAnt),
        resolveCondition(!primeiro, 'Documento de Aquisição', (dados === null || dados === void 0 ? void 0 : dados.documentoAquisicao)
            ? DocumentoAquisicaoEnum.getDescricao(dados === null || dados === void 0 ? void 0 : dados.documentoAquisicao)
            : ''),
    ];
};
export var livrFolhNumField = function (dados, numFull, isNum) {
    var _a, _b;
    if (numFull === void 0) { numFull = true; }
    if (isNum === void 0) { isNum = false; }
    return [
        {
            label: "".concat(isNum ? 'Número do ' : '', "Livro Fundi\u00E1rio"),
            value: (_a = dados === null || dados === void 0 ? void 0 : dados.outroLivro) !== null && _a !== void 0 ? _a : '',
        },
        {
            label: 'Folha Livro Fundiário',
            value: (_b = dados === null || dados === void 0 ? void 0 : dados.outraFolha) !== null && _b !== void 0 ? _b : '',
        },
        {
            label: 'Número do Título Definitivo',
            value: dados === null || dados === void 0 ? void 0 : dados.numeroTituloDefinitivo,
            fullWidth: numFull,
        },
    ];
};
export var artField = function (dados) {
    return {
        label: 'Número da ART (Anotação de Responsabilidade Técnica) ou RRT (Registro de Responsabilidade Técnica)',
        value: dados === null || dados === void 0 ? void 0 : dados.codigoArt,
        fullWidth: true,
    };
};
export var denoArField = function (dados, fullArea) {
    if (fullArea === void 0) { fullArea = false; }
    return [
        {
            label: 'Denominação',
            value: dados === null || dados === void 0 ? void 0 : dados.denominacao,
            fullWidth: true,
        },
        {
            label: 'Área (HA)',
            value: "".concat(prettyArea(dados === null || dados === void 0 ? void 0 : dados.area)),
            fullWidth: fullArea,
        },
    ];
};
export var denoArMunField = function (dados, atual, showMuni, fullArea) {
    var _a, _b;
    if (atual === void 0) { atual = true; }
    if (showMuni === void 0) { showMuni = true; }
    if (fullArea === void 0) { fullArea = false; }
    return __spreadArray(__spreadArray([], denoArField(dados, fullArea), true), [
        resolveOptCondition(showMuni, {
            label: resolveExpress(atual, 'Município Atual', 'Município'),
            value: "".concat((_a = dados === null || dados === void 0 ? void 0 : dados.municipio) === null || _a === void 0 ? void 0 : _a.uf, " - ").concat((_b = dados === null || dados === void 0 ? void 0 : dados.municipio) === null || _b === void 0 ? void 0 : _b.nome),
        }),
    ], false);
};
export var munDesMunAtualField = function (dados, opt, secondAt) {
    var _a, _b, _c, _d;
    if (secondAt === void 0) { secondAt = false; }
    var secondLbl = (secondAt ? NAO_SEI_INFO_MUNI_AT === null || NAO_SEI_INFO_MUNI_AT === void 0 ? void 0 : NAO_SEI_INFO_MUNI_AT.denominacao : NAO_SEI_INFO_MUNI_DESC === null || NAO_SEI_INFO_MUNI_DESC === void 0 ? void 0 : NAO_SEI_INFO_MUNI_DESC.denominacao);
    return [
        {
            label: 'Município descrito no documento',
            value: resolveExpress(!!((_a = dados === null || dados === void 0 ? void 0 : dados.municipioDesmembrado) === null || _a === void 0 ? void 0 : _a.id), (_b = dados === null || dados === void 0 ? void 0 : dados.municipioDesmembrado) === null || _b === void 0 ? void 0 : _b.denominacao, semMunicipioDeMt === null || semMunicipioDeMt === void 0 ? void 0 : semMunicipioDeMt.denominacao),
        },
        {
            label: 'Município atual',
            value: resolveExpress(!!((_c = dados === null || dados === void 0 ? void 0 : dados.municipioOrigem) === null || _c === void 0 ? void 0 : _c.id), (_d = dados === null || dados === void 0 ? void 0 : dados.municipioOrigem) === null || _d === void 0 ? void 0 : _d.denominacao, (opt !== null && opt !== void 0 ? opt : secondLbl)),
        },
    ];
};
export var munDesMunAtualFieldReq06 = function (dados, opt, secondAt) {
    var _a, _b;
    if (secondAt === void 0) { secondAt = false; }
    var secondLbl = secondAt
        ? NAO_SEI_INFO_MUNI_AT === null || NAO_SEI_INFO_MUNI_AT === void 0 ? void 0 : NAO_SEI_INFO_MUNI_AT.denominacao
        : NAO_SEI_INFO_MUNI_DESC === null || NAO_SEI_INFO_MUNI_DESC === void 0 ? void 0 : NAO_SEI_INFO_MUNI_DESC.denominacao;
    var municipioDescrito = dados === null || dados === void 0 ? void 0 : dados.municipioOrigem;
    var municipioAtual = dados === null || dados === void 0 ? void 0 : dados.municipio;
    return [
        {
            label: 'Município descrito no documento',
            value: resolveExpress(!!(municipioDescrito === null || municipioDescrito === void 0 ? void 0 : municipioDescrito.id), (_a = municipioDescrito === null || municipioDescrito === void 0 ? void 0 : municipioDescrito.denominacao) !== null && _a !== void 0 ? _a : municipioDescrito === null || municipioDescrito === void 0 ? void 0 : municipioDescrito.nome, semMunicipioDeMt === null || semMunicipioDeMt === void 0 ? void 0 : semMunicipioDeMt.denominacao),
        },
        {
            label: 'Município atual',
            value: resolveExpress(!!(municipioAtual === null || municipioAtual === void 0 ? void 0 : municipioAtual.id), (_b = municipioAtual === null || municipioAtual === void 0 ? void 0 : municipioAtual.denominacao) !== null && _b !== void 0 ? _b : municipioAtual === null || municipioAtual === void 0 ? void 0 : municipioAtual.nome, opt !== null && opt !== void 0 ? opt : secondLbl),
        },
    ];
};
export var sigefField = function (dados) {
    var temSigef = !!(dados === null || dados === void 0 ? void 0 : dados.codigoSIGEF);
    return [
        resolveOptCondition(temSigef, {
            label: 'Código SIGEF da Parcela',
            value: dados === null || dados === void 0 ? void 0 : dados.codigoSIGEF,
            fullWidth: true,
        }),
    ];
};
export var numCertField = function (dados) {
    return {
        label: 'Número da certificação',
        value: dados === null || dados === void 0 ? void 0 : dados.numeroCertificacao,
        fullWidth: true,
    };
};
export var matComField = function (dados) {
    var _a, _b;
    return [
        {
            label: 'Matricula',
            value: dados === null || dados === void 0 ? void 0 : dados.matricula,
        },
        {
            label: 'Comarca',
            value: (_b = (_a = dados === null || dados === void 0 ? void 0 : dados.comarca) === null || _a === void 0 ? void 0 : _a.denominacao) !== null && _b !== void 0 ? _b : '',
        },
    ];
};
export var sipraField = function (dados, fullWidth) {
    var _a;
    if (fullWidth === void 0) { fullWidth = true; }
    var semSipra = !(dados === null || dados === void 0 ? void 0 : dados.codigoSipra);
    return [
        {
            label: 'Possui cadastro do SIPRA?',
            value: resolveExpress(!semSipra, 'Sim', 'Não'),
            fullWidth: fullWidth && semSipra,
        },
        resolveCondition(!semSipra, 'Código SIPRA do Assentado', "".concat((_a = dados === null || dados === void 0 ? void 0 : dados.codigoSipra) !== null && _a !== void 0 ? _a : '')),
    ];
};
export var baseLegOrEstCadField = function (dados, matFieldFull) {
    var _a, _b, _c;
    if (matFieldFull === void 0) { matFieldFull = true; }
    var fields = [];
    var docAq = (_a = dados === null || dados === void 0 ? void 0 : dados.documentoAquisicao) !== null && _a !== void 0 ? _a : DocumentoAquisicaoEnum.ESCRITURA_PUBLICA_DEC_POSSE;
    var isSigef = (dados === null || dados === void 0 ? void 0 : dados.pecasTecnicas) === TipoParcelaEnum.SIGEF;
    var isSnci = (dados === null || dados === void 0 ? void 0 : dados.pecasTecnicas) === TipoParcelaEnum.SNCI;
    var isConv = (!isSnci && !isSigef);
    var isMatricula = reverseDocumentoMap[docAq] === 'matricula';
    var isEscritura = reverseDocumentoMap[docAq] === 'escritura';
    var isTitulo = reverseDocumentoMap[docAq] === 'titulo';
    if (isConv || isSnci) {
        if (isTitulo && !isSnci) {
            fields = [
                {
                    label: 'Livro Fundiário',
                    value: (_b = dados === null || dados === void 0 ? void 0 : dados.outroLivro) !== null && _b !== void 0 ? _b : '',
                },
                {
                    label: 'Folha Livro Fundiário',
                    value: (_c = dados === null || dados === void 0 ? void 0 : dados.outraFolha) !== null && _c !== void 0 ? _c : '',
                },
                {
                    label: 'Número do Título Definitivo',
                    value: dados === null || dados === void 0 ? void 0 : dados.numeroTituloDefinitivo,
                    fullWidth: true,
                },
            ];
        }
        if (isMatricula) {
            fields = [
                {
                    value: dados === null || dados === void 0 ? void 0 : dados.matricula,
                    label: 'Matricula',
                    fullWidth: matFieldFull,
                },
            ];
        }
        if (isEscritura) {
            fields = [
                {
                    value: dados === null || dados === void 0 ? void 0 : dados.matricula,
                    label: 'Escritura',
                    fullWidth: matFieldFull,
                },
            ];
        }
    }
    if (!isConv && isTitulo) {
        fields = [
            {
                label: 'Número do Título Definitivo',
                value: dados === null || dados === void 0 ? void 0 : dados.numeroTituloDefinitivo,
                fullWidth: matFieldFull,
            },
        ];
    }
    return __spreadArray([], fields, true);
};
export var dadosImvBuscPesq = function (dados) {
    var _a, _b, _c, _d, _e, _f, _g;
    var showArea = !!(dados === null || dados === void 0 ? void 0 : dados.tipoArea) &&
        !((dados === null || dados === void 0 ? void 0 : dados.tipoArea) === TipoAreaEnum.Todos ||
            (dados === null || dados === void 0 ? void 0 : dados.tipoArea) === TipoAreaEnum.Individual);
    return __spreadArray(__spreadArray(__spreadArray([
        {
            label: 'CPF do Proprietário',
            value: (_a = dados === null || dados === void 0 ? void 0 : dados.proprietario) === null || _a === void 0 ? void 0 : _a.cpf,
        },
        {
            label: 'Nome do Proprietário',
            value: (_b = dados === null || dados === void 0 ? void 0 : dados.proprietario) === null || _b === void 0 ? void 0 : _b.nome,
        }
    ], munDesMunAtualField(dados, NAO_SEI_INFO_MUNI_AT === null || NAO_SEI_INFO_MUNI_AT === void 0 ? void 0 : NAO_SEI_INFO_MUNI_AT.denominacao), true), livrFolhNumField(dados, false), true), [
        {
            label: 'Data de expedição do Título Definitivo',
            value: (dados === null || dados === void 0 ? void 0 : dados.dataExpedicaoTituloDefinitivo)
                ? DateUtils.formatDate(new Date("".concat(dados === null || dados === void 0 ? void 0 : dados.dataExpedicaoTituloDefinitivo, " 23:00")))
                : undefined,
        },
        {
            label: 'Número da Matrícula do Imóvel',
            value: (_d = (_c = dados === null || dados === void 0 ? void 0 : dados.matriculas) === null || _c === void 0 ? void 0 : _c[0]) !== null && _d !== void 0 ? _d : dados === null || dados === void 0 ? void 0 : dados.matricula,
        },
        {
            label: 'Área (HA)',
            value: "".concat(prettyArea(dados === null || dados === void 0 ? void 0 : dados.area)),
        },
        {
            label: 'Tipo de Área',
            value: "".concat(TipoAreaEnum.getDescricao((_e = dados === null || dados === void 0 ? void 0 : dados.tipoArea) !== null && _e !== void 0 ? _e : TipoAreaEnum.Todos)),
            fullWidth: !showArea,
        },
        resolveOptCondition(showArea, {
            label: "".concat(TipoAreaEnum.getDescricao(dados === null || dados === void 0 ? void 0 : dados.tipoArea)),
            value: "".concat((_g = (_f = dados === null || dados === void 0 ? void 0 : dados.projetoFundiario) === null || _f === void 0 ? void 0 : _f.nome) !== null && _g !== void 0 ? _g : 'Ambos'),
        }),
        {
            label: 'Denominação da área do imóvel',
            value: "".concat(dados === null || dados === void 0 ? void 0 : dados.denominacao),
            fullWidth: true,
        },
        {
            label: 'Informações Adicionais',
            value: (dados === null || dados === void 0 ? void 0 : dados.informacoesAdicionais)
                ? CommonUtils.stripHtml(dados.informacoesAdicionais).trim()
                : undefined,
            fullWidth: true,
        },
    ], false);
};
export var dadosImvCertIntTeor = function (dados) {
    var _a;
    var fields = [];
    if ((dados === null || dados === void 0 ? void 0 : dados.tipoImovel) === TipoImovelEnum.URBANO) {
        fields = __spreadArray(__spreadArray(__spreadArray([], projQdrLotField(dados, true, true), true), emptyBlocks(2, true), true), [
            {
                label: 'CEP do imóvel',
                value: dados === null || dados === void 0 ? void 0 : dados.cepImovel,
            },
            dataOcpMMMMYYYY(dados),
        ], false);
    }
    return __spreadArray(__spreadArray(__spreadArray(__spreadArray([
        {
            value: TipoImovelEnum.getDescricao((_a = dados === null || dados === void 0 ? void 0 : dados.tipoImovel) !== null && _a !== void 0 ? _a : TipoImovelEnum.RURAL),
            label: 'Tipo do Imóvel?',
            fullWidth: true,
        }
    ], munDesMunAtualFieldReq06(dados), true), fields, true), livrFolhNumField(dados, true, false), true), [
        {
            value: (dados === null || dados === void 0 ? void 0 : dados.orgaoResponsavel)
                ? OrgaoResponsavelEnum.getDescricao(dados === null || dados === void 0 ? void 0 : dados.orgaoResponsavel)
                : '',
            label: 'Orgão responsável pela titulação',
            fullWidth: true,
        },
    ], false);
};
export var dadosImvLocalRural = function (dados) {
    var _a, _b, _c, _d, _e, _f, _g;
    var isAssentamento = (dados === null || dados === void 0 ? void 0 : dados.tipoArea) === TipoAreaEnum.Assentamento;
    var showProj = isAssentamento || (dados === null || dados === void 0 ? void 0 : dados.tipoArea) === TipoAreaEnum.Gleba;
    var semProj = !((_a = dados === null || dados === void 0 ? void 0 : dados.projetoFundiario) === null || _a === void 0 ? void 0 : _a.id);
    var label = "Informe qual ".concat(isAssentamento ? 'o' : 'a', " ").concat((dados === null || dados === void 0 ? void 0 : dados.tipoArea) && TipoAreaEnum.getDescricao(dados === null || dados === void 0 ? void 0 : dados.tipoArea));
    var outroProj = isAssentamento
        ? 'Quero informar um Assentamento que não esta na lista'
        : 'Quero informar uma Gleba que não esta na lista';
    var utilizmatr = !!((_c = (_b = dados === null || dados === void 0 ? void 0 : dados.matriculas) === null || _b === void 0 ? void 0 : _b[0]) !== null && _c !== void 0 ? _c : dados === null || dados === void 0 ? void 0 : dados.matricula);
    var isIndividual = ((_d = dados === null || dados === void 0 ? void 0 : dados.tipoArea) !== null && _d !== void 0 ? _d : TipoAreaEnum.Individual) === TipoAreaEnum.Individual;
    return __spreadArray(__spreadArray([
        {
            label: 'Denominação do Imóvel',
            value: dados === null || dados === void 0 ? void 0 : dados.denominacao,
            fullWidth: true,
        }
    ], munDesMunAtualField(dados, undefined, true), true), [
        {
            value: (dados === null || dados === void 0 ? void 0 : dados.tipoArea) ? TipoAreaEnum.getDescricao(dados === null || dados === void 0 ? void 0 : dados.tipoArea) : '',
            label: 'Tipo de Área',
            fullWidth: isIndividual,
        },
        resolveOptCondition(showProj, {
            label: "".concat(label, "?"),
            value: resolveExpress(!semProj, (_e = dados === null || dados === void 0 ? void 0 : dados.projetoFundiario) === null || _e === void 0 ? void 0 : _e.nome, outroProj),
        }),
        resolveOptCondition(showProj && semProj, {
            label: "".concat(label, " n\u00E3o listado"),
            value: dados === null || dados === void 0 ? void 0 : dados.outroProjeto,
            fullWidth: true,
        }),
        {
            value: resolveExpress(utilizmatr, 'Matrícula', 'Escritura'),
            label: 'Deseja utilizar qual documento?',
            fullWidth: true,
        },
        {
            label: resolveExpress(utilizmatr, 'Número da Matrícula', 'Número da Escritura'),
            value: resolveExpress(utilizmatr, (_g = (_f = dados === null || dados === void 0 ? void 0 : dados.matriculas) === null || _f === void 0 ? void 0 : _f[0]) !== null && _g !== void 0 ? _g : dados === null || dados === void 0 ? void 0 : dados.matricula, dados === null || dados === void 0 ? void 0 : dados.numeroEscritura),
            fullWidth: true,
        },
    ], false);
};
export var dadosImvDomEmpRural = function (dados) {
    var _a, _b, _c, _d;
    return [
        {
            label: 'Tipo de Requerente',
            value: (dados === null || dados === void 0 ? void 0 : dados.tipoProprietario)
                ? TipoProprietarioEnum.getDescricao(dados === null || dados === void 0 ? void 0 : dados.tipoProprietario)
                : '',
        },
        {
            label: 'Tipo do Documento de Domínio do Imóvel',
            value: (dados === null || dados === void 0 ? void 0 : dados.tipoDocumentoDominio)
                ? TipoDocDominioEnum.getDescricao(dados === null || dados === void 0 ? void 0 : dados.tipoDocumentoDominio)
                : '',
        },
        {
            value: resolveExpress((dados === null || dados === void 0 ? void 0 : dados.possuiSede) === true, 'Sim', 'Não'),
            label: 'O empreendimento rural possui sede?',
            fullWidth: true
        },
        resolveOptCondition((dados === null || dados === void 0 ? void 0 : dados.possuiSede) === true, { label: 'Latitude', value: (_a = dados === null || dados === void 0 ? void 0 : dados.latitude) !== null && _a !== void 0 ? _a : '' }),
        resolveOptCondition((dados === null || dados === void 0 ? void 0 : dados.possuiSede) === true, { label: 'Longitude', value: (_b = dados === null || dados === void 0 ? void 0 : dados.longitude) !== null && _b !== void 0 ? _b : '' }),
        {
            value: resolveExpress((dados === null || dados === void 0 ? void 0 : dados.possuiAreaProdutiva) === true, 'Sim', 'Não'),
            label: 'O empreendimento rural possui área produtiva?',
            fullWidth: true
        },
        resolveOptCondition((dados === null || dados === void 0 ? void 0 : dados.possuiAreaProdutiva) === true, { label: 'Latitude', value: (_c = dados === null || dados === void 0 ? void 0 : dados.latitude) !== null && _c !== void 0 ? _c : '' }),
        resolveOptCondition((dados === null || dados === void 0 ? void 0 : dados.possuiAreaProdutiva) === true, { label: 'Longitude', value: (_d = dados === null || dados === void 0 ? void 0 : dados.longitude) !== null && _d !== void 0 ? _d : '' }),
    ];
};
export var dadosImvTiDefUrb = function (dados) {
    var _a, _b, _c, _d;
    return __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([
        {
            label: 'Município',
            value: "".concat((_a = dados === null || dados === void 0 ? void 0 : dados.municipio) === null || _a === void 0 ? void 0 : _a.uf, " - ").concat((_b = dados === null || dados === void 0 ? void 0 : dados.municipio) === null || _b === void 0 ? void 0 : _b.nome),
        }
    ], projQdrLotField(dados, false, false, true), true), emptyBlocks(2, true), true), [
        {
            label: 'CEP do imóvel',
            value: dados === null || dados === void 0 ? void 0 : dados.cepImovel,
        },
        dataOcpMMMMYYYY(dados)
    ], false), livrFolhNumField(dados), true), [
        {
            label: 'Matricula',
            value: (_d = (_c = dados === null || dados === void 0 ? void 0 : dados.matriculas) === null || _c === void 0 ? void 0 : _c[0]) !== null && _d !== void 0 ? _d : dados === null || dados === void 0 ? void 0 : dados.matricula,
        }
    ], false), emptyBlocks(2, true), true), [
        {
            label: 'Portaria de Ratificação INTERMAT',
            value: (dados === null || dados === void 0 ? void 0 : dados.portariaRatificacao)
                ? PortariaRatificacaoUrbanaEnum.getDescricao(dados === null || dados === void 0 ? void 0 : dados.portariaRatificacao)
                : '',
        },
    ], false);
};
export var dadosImvRuralAssent = function (dados) {
    var _a, _b, _c, _d, _e;
    var first = (dados === null || dados === void 0 ? void 0 : dados.primeiroProprietario) === true;
    var semProj = !((_a = dados === null || dados === void 0 ? void 0 : dados.projetoFundiario) === null || _a === void 0 ? void 0 : _a.id);
    var semLote = !((_b = dados === null || dados === void 0 ? void 0 : dados.lote) === null || _b === void 0 ? void 0 : _b.id);
    return __spreadArray(__spreadArray(__spreadArray(__spreadArray([
        {
            value: "".concat((_c = dados === null || dados === void 0 ? void 0 : dados.municipio) === null || _c === void 0 ? void 0 : _c.uf, " - ").concat((_d = dados === null || dados === void 0 ? void 0 : dados.municipio) === null || _d === void 0 ? void 0 : _d.nome),
            label: 'Município',
            fullWidth: semProj,
        }
    ], projField(dados, true, true, false), true), [
        {
            label: 'Lote',
            value: resolveExpress(!semLote, (_e = dados === null || dados === void 0 ? void 0 : dados.lote) === null || _e === void 0 ? void 0 : _e.denominacao, outrosOpt === null || outrosOpt === void 0 ? void 0 : outrosOpt.denominacao),
        },
        resolveCondition(semLote, 'Qual a lote?', dados === null || dados === void 0 ? void 0 : dados.outroLote),
        dataOcpMMMMYYYY(dados, semLote)
    ], false), primeiroOcpField(dados, !first), true), sipraField(dados, !first), true);
};
var dadosImvRegRural = function (dados) {
    return __spreadArray([dataOcpMMMMYYYY(dados, true)], primeiroOcpField(dados), true);
};
export var dadosImv = function (tipoRequerimento, dados) {
    switch (tipoRequerimento) {
        case TipoProcessoEnum.BUSCA_PESQUISA:
            return dadosImvBuscPesq(dados);
        case TipoProcessoEnum.CERTIDAO_INTEIRO_TEOR_RURAL_URBANO:
            return dadosImvCertIntTeor(dados);
        case TipoProcessoEnum.CERTIDAO_LOCALIZACAO_RURAL:
            return dadosImvLocalRural(dados);
        case TipoProcessoEnum.CERTIDAO_DOMICILIO_FISCAL_EMP_RURAL:
            return dadosImvDomEmpRural(dados);
        case TipoProcessoEnum.RATIFICACAO_TITULO_DEF_URBANO:
            return dadosImvTiDefUrb(dados);
        case TipoProcessoEnum.REGULARIZACAO_FUND_RURAL_ASSENTAMENTO:
            return dadosImvRuralAssent(dados);
        case TipoProcessoEnum.REGULARIZACAO_RURAL:
            return dadosImvRegRural(dados);
        default:
            return [];
    }
};
var parcelaAverbTiJud = function (dados) {
    return __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], livrFolhNumField(dados), true), emptyBlocks(1, true), true), sigefField(dados), true), denoArMunField(dados), true), [
        artField(dados),
    ], false);
};
var parcelaCertIntTeor = function (dados, dadosImv) {
    var camposBase = __spreadArray(__spreadArray([], resolveOptArrCondition((dadosImv === null || dadosImv === void 0 ? void 0 : dadosImv.tipoImovel) === TipoImovelEnum.RURAL, denoArMunField(dados, true, false, true)), true), [
        artField(dados),
    ], false);
    return __spreadArray([], camposBase, true);
};
var parcelaLetOrig = function (dados) {
    var _a, _b, _c;
    var fields = [];
    var docAq = (_a = dados === null || dados === void 0 ? void 0 : dados.documentoAquisicao) !== null && _a !== void 0 ? _a : DocumentoAquisicaoEnum.ESCRITURA_PUBLICA_DEC_POSSE;
    var isSigef = (dados === null || dados === void 0 ? void 0 : dados.pecasTecnicas) === TipoParcelaEnum.SIGEF;
    if (!isSigef) {
        if (reverseDocumentoMap[docAq] === 'titulo') {
            fields = [
                {
                    label: 'Livro Fundiário',
                    value: (_b = dados === null || dados === void 0 ? void 0 : dados.outroLivro) !== null && _b !== void 0 ? _b : '',
                },
                {
                    label: 'Folha Livro Fundiário',
                    value: (_c = dados === null || dados === void 0 ? void 0 : dados.outraFolha) !== null && _c !== void 0 ? _c : '',
                },
                {
                    label: 'Número do Título Definitivo',
                    value: dados === null || dados === void 0 ? void 0 : dados.numeroTituloDefinitivo,
                    fullWidth: true,
                },
            ];
        }
        if (reverseDocumentoMap[docAq] === 'matricula') {
            fields = [
                {
                    value: dados === null || dados === void 0 ? void 0 : dados.matricula,
                    label: 'Matricula',
                    fullWidth: true,
                },
            ];
        }
        if (reverseDocumentoMap[docAq] === 'escritura') {
            fields = [
                {
                    value: dados === null || dados === void 0 ? void 0 : dados.matricula,
                    label: 'Escritura',
                    fullWidth: true,
                },
            ];
        }
    }
    else if (reverseDocumentoMap[docAq] === 'titulo') {
        fields = [
            {
                label: 'Número do Título Definitivo',
                value: dados === null || dados === void 0 ? void 0 : dados.numeroTituloDefinitivo,
                fullWidth: true,
            },
        ];
    }
    return __spreadArray(__spreadArray(__spreadArray(__spreadArray([
        {
            value: (dados === null || dados === void 0 ? void 0 : dados.documentoAquisicao)
                ? reverseDocumentoMapPretty[dados === null || dados === void 0 ? void 0 : dados.documentoAquisicao]
                : 'Mátricula',
            label: 'Deseja utilizar qual documento?',
            fullWidth: true,
        },
        resolveOptCondition(!isSigef, numCertField(dados))
    ], sigefField(dados), true), denoArMunField(dados), true), fields, true), [
        artField(dados),
    ], false);
};
var parcelaEstdCad = function (dados) {
    var _a, _b;
    var isSigef = (dados === null || dados === void 0 ? void 0 : dados.pecasTecnicas) === TipoParcelaEnum.SIGEF;
    var isSnci = (dados === null || dados === void 0 ? void 0 : dados.pecasTecnicas) === TipoParcelaEnum.SNCI;
    var fields = baseLegOrEstCadField(dados, !isSnci);
    return __spreadArray(__spreadArray(__spreadArray(__spreadArray([
        {
            value: (dados === null || dados === void 0 ? void 0 : dados.documentoAquisicao) ? reverseDocumentoMapPretty[dados === null || dados === void 0 ? void 0 : dados.documentoAquisicao] : 'Mátricula',
            label: 'Deseja utilizar qual documento?',
            fullWidth: true,
        },
        resolveOptCondition(isSnci, numCertField(dados))
    ], resolveOptArrCondition(isSigef, sigefField(dados)), true), denoArMunField(dados), true), fields, true), [
        resolveOptCondition(isSnci, { label: 'Comarca', value: (_b = (_a = dados === null || dados === void 0 ? void 0 : dados.comarca) === null || _a === void 0 ? void 0 : _a.denominacao) !== null && _b !== void 0 ? _b : '' }),
        resolveOptCondition(!isSnci, artField(dados)),
    ], false);
};
var parcelaUsuCapRural = function (dados) {
    return __spreadArray(__spreadArray(__spreadArray([], munDesMunAtualField(dados), true), denoArField(dados, true), true), [
        artField(dados),
    ], false);
};
var parcelaAssentado = function (dados) {
    var _a, _b, _c, _d, _e, _f;
    var semProj = !((_a = dados === null || dados === void 0 ? void 0 : dados.projetoFundiario) === null || _a === void 0 ? void 0 : _a.id);
    var semLote = !((_b = dados === null || dados === void 0 ? void 0 : dados.lote) === null || _b === void 0 ? void 0 : _b.id);
    return __spreadArray(__spreadArray(__spreadArray([
        {
            value: "".concat((_c = dados === null || dados === void 0 ? void 0 : dados.municipio) === null || _c === void 0 ? void 0 : _c.uf, " - ").concat((_d = dados === null || dados === void 0 ? void 0 : dados.municipio) === null || _d === void 0 ? void 0 : _d.nome),
            label: 'Município',
            fullWidth: semProj,
        },
        {
            label: 'Denominação do Projeto de Assentamento',
            value: resolveExpress(!semProj, (_e = dados === null || dados === void 0 ? void 0 : dados.projetoFundiario) === null || _e === void 0 ? void 0 : _e.nome, outrosOpt.denominacao),
        },
        resolveCondition(semProj, 'Nome do projeto de assentamento', dados === null || dados === void 0 ? void 0 : dados.outroProjeto),
        {
            label: 'Lote',
            value: resolveExpress(!semLote, (_f = dados === null || dados === void 0 ? void 0 : dados.lote) === null || _f === void 0 ? void 0 : _f.denominacao, outrosOpt.denominacao),
        },
        resolveCondition(semLote, 'Nome do Lote', dados === null || dados === void 0 ? void 0 : dados.outroLote),
        dataOcpMMMMYYYY(dados, semLote)
    ], emptyBlocks(2, true), true), sipraField(dados), true), [
        {
            label: 'Qual a finalidade da Declaração?',
            value: (dados === null || dados === void 0 ? void 0 : dados.finalidadeDeclaracao)
                ? FinalidadeDeclaracaoEnum.getDescricao(dados === null || dados === void 0 ? void 0 : dados.finalidadeDeclaracao)
                : '',
        },
        {
            label: 'Área (HA)',
            value: "".concat(prettyArea(dados === null || dados === void 0 ? void 0 : dados.area)),
        },
    ], false);
};
var parcelaRecLimite = function (dados) {
    var isSigef = (dados === null || dados === void 0 ? void 0 : dados.pecasTecnicas) === TipoParcelaEnum.SIGEF;
    var _sigefField = sigefField(dados);
    var numCertFiedl = [numCertField(dados)];
    var firstField = isSigef
        ? _sigefField
        : numCertFiedl;
    return __spreadArray(__spreadArray(__spreadArray([], firstField, true), denoArMunField(dados, true), true), matComField(dados), true);
};
var parcelaDomEmpRural = function (dados) {
    var baseFiels = [];
    switch (dados === null || dados === void 0 ? void 0 : dados.pecasTecnicas) {
        case TipoParcelaEnum.SIGEF:
            baseFiels = __spreadArray([], sigefField(dados), true);
            break;
        case TipoParcelaEnum.SNCI:
            baseFiels = [numCertField(dados)];
    }
    var lastFields = [];
    if ((dados === null || dados === void 0 ? void 0 : dados.pecasTecnicas) === TipoParcelaEnum.CONVENCIONAIS) {
        lastFields = [artField(dados)];
    }
    else {
        lastFields = __spreadArray([], matComField(dados), true);
    }
    return __spreadArray(__spreadArray(__spreadArray([], baseFiels, true), denoArMunField(dados), true), lastFields, true);
};
var parcelaFundUrb = function (dados) {
    var _a, _b, _c, _d;
    var semProj = !((_a = dados === null || dados === void 0 ? void 0 : dados.projetoFundiario) === null || _a === void 0 ? void 0 : _a.id);
    return __spreadArray(__spreadArray(__spreadArray(__spreadArray([
        {
            label: 'Município',
            value: "".concat((_b = dados === null || dados === void 0 ? void 0 : dados.municipio) === null || _b === void 0 ? void 0 : _b.uf, " - ").concat((_c = dados === null || dados === void 0 ? void 0 : dados.municipio) === null || _c === void 0 ? void 0 : _c.nome),
            fullWidth: semProj,
        }
    ], projQdrLotField(dados, true, false, true), true), [
        {
            label: 'CEP do imóvel',
            value: dados === null || dados === void 0 ? void 0 : dados.cepImovel,
        },
        dataOcpMMMMYYYY(dados)
    ], false), primeiroOcpField(dados), true), [
        resolveOptCondition(!!((_d = dados === null || dados === void 0 ? void 0 : dados.responsavelTecnico) === null || _d === void 0 ? void 0 : _d.id), artField(dados)),
    ], false);
};
var parcelaRuralAssent = function (dados) {
    return __spreadArray(__spreadArray(__spreadArray([], sigefField(dados), true), denoArMunField(dados, true), true), [
        artField(dados),
    ], false);
};
var parcelaTitDef = function (dados) {
    var _a, _b;
    var notaDevolutiva = (dados === null || dados === void 0 ? void 0 : dados.notaDevolutiva) === true;
    var field = [];
    if ((dados === null || dados === void 0 ? void 0 : dados.tipoImovel) === TipoImovelEnum.URBANO) {
        field = __spreadArray([], projQdrLotField(dados, true, true), true);
    }
    else {
        var showProj = (dados === null || dados === void 0 ? void 0 : dados.tipoArea) !== TipoAreaEnum.Individual;
        var isAssentamento = (dados === null || dados === void 0 ? void 0 : dados.tipoArea) === TipoAreaEnum.Assentamento;
        var outroProj = isAssentamento
            ? 'Quero informar um Assentamento que não esta na lista'
            : 'Quero informar uma Gleba que não esta na lista';
        var label = "Informe qual ".concat(isAssentamento ? 'o' : 'a', " ").concat((dados === null || dados === void 0 ? void 0 : dados.tipoArea) && TipoAreaEnum.getDescricao(dados === null || dados === void 0 ? void 0 : dados.tipoArea));
        var semProj = !((_a = dados === null || dados === void 0 ? void 0 : dados.projetoFundiario) === null || _a === void 0 ? void 0 : _a.id);
        field = [
            {
                label: 'Tipo de Área',
                value: (dados === null || dados === void 0 ? void 0 : dados.tipoArea)
                    ? TipoAreaEnum.getDescricao(dados === null || dados === void 0 ? void 0 : dados.tipoArea)
                    : '',
            },
            resolveOptCondition(showProj, {
                label: "".concat(label, "?"),
                value: resolveExpress(!semProj, (_b = dados === null || dados === void 0 ? void 0 : dados.projetoFundiario) === null || _b === void 0 ? void 0 : _b.nome, outroProj),
            }),
            resolveOptCondition(showProj && semProj, {
                label: "Nome ".concat(isAssentamento ? 'do' : 'da', " ").concat((dados === null || dados === void 0 ? void 0 : dados.tipoArea) && TipoAreaEnum.getDescricao(dados === null || dados === void 0 ? void 0 : dados.tipoArea)),
                value: dados === null || dados === void 0 ? void 0 : dados.outroProjeto,
                fullWidth: true,
            }),
            {
                label: 'Denominação do Imóvel',
                value: dados === null || dados === void 0 ? void 0 : dados.denominacao,
                fullWidth: true,
            },
        ];
    }
    return __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([
        {
            label: 'O título a ser retificado passou por processo de compra e venda?',
            value: resolveExpress((dados === null || dados === void 0 ? void 0 : dados.compraVenda) === true, 'Sim', 'Não'),
            fullWidth: true,
        },
        {
            label: 'Existe Nota Devolutiva de Cartório?',
            value: resolveExpress(notaDevolutiva, 'Sim', 'Não'),
            fullWidth: true,
        },
        resolveOptCondition(!notaDevolutiva, {
            label: 'Descrição das informações a serem ratificadas no título',
            value: dados === null || dados === void 0 ? void 0 : dados.descricaoRatificada,
            type: 'text-editor',
            fullWidth: true,
        })
    ], emptyBlocks(2, true), true), munDesMunAtualField(dados), true), livrFolhNumField(dados), true), emptyBlocks(2, true), true), field, true);
};
export var dadosParcela = function (tipoRequerimento, dados, dadosImv) {
    switch (tipoRequerimento) {
        case TipoProcessoEnum.AVERBACAO_TITULO_JUDICIAL:
            return parcelaAverbTiJud(dados);
        case TipoProcessoEnum.CERTIDAO_INTEIRO_TEOR_RURAL_URBANO:
            return parcelaCertIntTeor(dados, dadosImv);
        case TipoProcessoEnum.CERTIDAO_LEGITIMIDADE_ORIG:
            return parcelaLetOrig(dados);
        case TipoProcessoEnum.ESTD_CAD:
            return parcelaEstdCad(dados);
        case TipoProcessoEnum.CERTIDAO_FINS_USUCAPIAO_RURAL:
            return parcelaUsuCapRural(dados);
        case TipoProcessoEnum.DECLARACAO_ASSENTADO:
            return parcelaAssentado(dados);
        case TipoProcessoEnum.DECLARACAO_RECONHECIMENTO_LIMITES:
            return parcelaRecLimite(dados);
        case TipoProcessoEnum.CERTIDAO_DOMICILIO_FISCAL_EMP_RURAL:
            return parcelaDomEmpRural(dados);
        case TipoProcessoEnum.REGULARIZACAO_FUNDIARIA_URBANA:
            return parcelaFundUrb(dados);
        case TipoProcessoEnum.REGULARIZACAO_FUND_RURAL_ASSENTAMENTO:
            return parcelaRuralAssent(dados);
        case TipoProcessoEnum.REGULARIZACAO_RURAL:
            return parcelaRuralAssent(dados);
        case TipoProcessoEnum.RETIFICACAO_TITULO_DEFINITIVO:
            return parcelaTitDef(dados);
        default:
            return [];
    }
};
